<template>
    <!--手机精品推荐 -->
    <!-- 导航栏 -->
    <ZhaiHead></ZhaiHead>
    <!--二个按钮-->
    <div class="zhu mb-2">
        <ZhaiTwoTuttons></ZhaiTwoTuttons>
    </div>
    <!--二个按钮-->
    <!-- 主体部分 -->
    <div class="container-fluid shengse  mb-2">
        <div class="row shengse ">
            <div class="dixian px-3 py-2 d-flex ">
                <i class="bi bi-cup"></i>精品入驻推荐
            </div>
        </div>

    </div>
    <!-- 卡片展示区 -->
    <div class="container-fluid mt-2 px-0">
        <div class="row card-container">
            <div class="col-md-4 mb-1 card" v-for="item in posts" :key="item.id">
                <a @click.prevent="handleCardClick(item)" class="card-link">
                    <div class="card h-100">
                        <div class="row g-0 h-100">
                            <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                                <div class="image-container">
                                    <img :src="item.img" alt="..." class="card-img">
                                </div>
                            </div>
                            <div class="col-8 d-flex flex-column h-100">
                                <div class="card-body p-1 d-flex flex-column h-100">
                                    <div class="header flex-shrink-0">
                                        <h5 class="card-title mt-3">{{ item.name }}</h5>
                                        <div class="ri mb-1 mt-2">
                                            <i class="bi bi-clock riqiziti">
                                                <span>&nbsp;{{ item.createTime.substr(0, 10) }}&nbsp;&nbsp;</span>
                                            </i>
                                            <i class="bi bi-star-fill riqiziti">
                                                <span>&nbsp;{{ item.collectCount }}收藏</span>
                                            </i>
                                        </div>
                                    </div>
                                    <div class="content flex-grow-1">
                                        <p class="card-text">{{ item.history }}</p>
                                    </div>
                                    <div class="footer mb-2 flex-shrink-0">
                                            <span class="bi bi-send-fill weiz changlv">
                                                &nbsp;{{ item.province }}-{{ item.city }}
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div style="text-align: center;font-size: 1rem;color: #00ad63;margin: 2rem 0;font-weight: bold;padding: 0 1rem;">现开启会所商家/经纪人入驻，给我们发送邮件或者联系网页底部客服 办理入驻。</div>

    <!-- 分页 -->
    <div v-if="posts.length > 0" class="bg-white my-2 p-3 G-Field text-center d-flex justify-content-center align-items-center">
        <a class="page-link pagination-btn" href="#" aria-label="Previous" @click.prevent="prevPage" :disabled="currentPage === 1">
            <span aria-hidden="true">«</span>
        </a>
        <span style="margin: 0 1rem;">第 {{ pageNum }} 页，共 {{ totalPages }} 页</span>
        <a class="page-link pagination-btn" href="#" aria-label="Next" @click.prevent="nextPage" :disabled="currentPage === totalPages">
            <span aria-hidden="true">»</span>
        </a>
    </div>

    <!-- 公共底部 -->
    <ZhaiFoot></ZhaiFoot>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import http from "../utils/http.js";
    import ZhaiTwoTuttons from "../components/ZhaiTwoTuttons";

    export default {
        name: "MEnter",
        components: { ZhaiHead, ZhaiFoot,ZhaiTwoTuttons },
        data() {
            return {
                posts: [], // 存储获取到的推荐数据
                pageNum: 1, // 当前页码
                pageSize: 24, // 每页显示条数
                totalPages: 1 // 总页数
            };
        },
        mounted() {
            this.fetchPosts();
        },
        methods: {
            fetchPosts() { const url = `/platform/frontEnd/recommendSpecial?pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
                http.get(url)
                    .then((response) => {
                        if (response.data && response.data.status === 1) {
                            this.posts = response.data.data.list;
                            this.totalPages = Math.ceil(response.data.data.total / this.pageSize);
                        } else {
                            console.error("获取推荐数据失败:", response.data.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("API 请求错误:", error);
                    });
            },
            // 上一页
            prevPage() {
                if (this.pageNum > 1) {
                    this.pageNum--;
                    this.fetchPosts();
                }
            },
            // 下一页
            nextPage() {
                if (this.pageNum < this.totalPages) {
                    this.pageNum++;
                    this.fetchPosts();
                }
            },
            handleCardClick(post) {
                // 跳转到详情页面
                this.$router.push({
                    name: "detailPage2",
                    query: { id: post.id },
                });
            }
        }
    };
</script>

<style scoped>
    .pagination {
        display: block;
    }
    .zhu {
        margin-top: 85px;
    }
    .card-title{
        font-weight: bold;
    }

    .pagination li {
        display: inline-block;
        margin-left: 2px;
        border: 1px solid #ededed;
        padding: 0 12px;
        color: #3e3e3e;
        line-height: 30px;
        font-size: 16px;
        text-decoration: none;
    }

    .card-container {
        display: flex;
        flex-wrap: wrap;
        margin-left: -1px;
        margin-right: -1px;
    }

    .col-md-4 {
        padding-left: 2px;
        padding-right: 2px;
        display: flex;
    }

    .pagination-btn {
        background: none;
        border: 1px solid #dee2e6;
        border-radius: 2px;
        cursor: pointer;
        padding: 0.3rem 0.75rem;
        font-size: 1.2rem;
        color: black;
        text-decoration: none;
        display: flex;
        align-items: center;
        transition: background-color 0.3s ease;
    }

    .pagination-btn:hover {
        background-color: #f8f9fa;
        border-color: #dee2e6;
    }

    .pagination-btn:disabled {
        color: #dee2e6;
        cursor: not-allowed;
        border-color: #dee2e6;
    }
    .bi {
        margin-right: 2px; /* 图标和文字之间的间距 */
    }
    /*卡片样式*/
    .card {
        border: none;
    }
    body, .card {
        font-size: 16px;
    }
    .card {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        border: none;
    }
    .col-4 {
        width: 115px;
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0;
    }
    .image-container {
        width: 99px;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 4px;
    }
    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .col-8 {
        max-height: 155px;
    }
    .card-body {
        display: flex;
        flex-direction: column;
        padding: 0.1rem;
        height: 100%;
    }
    .card-title {
        font-size: 1rem;
    }
    .card-text {
        margin-bottom: 1rem !important;
        font-size: 0.9rem !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .daxiao {
        font-size: 0.75rem !important;
    }
    .ri {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
    }
    .riqiziti {
        font-style: normal;
        font-size: 0.8rem;
        margin-right: 4px;
    }
    .ri i + i {
        margin-left: 4px;
    }
    .changlv {
        color: #18b371 !important;
    }
    .content {
        display: flex;
        flex-direction: column;
        margin-top: 0.2rem;
    }
    .card-link {
        text-decoration: none;
        color: inherit;
    }
    .weiz {
        font-size: 0.9rem;
    }
</style>
